var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764:1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.671128 10.8919H2.66199V11.5555H0.00750732V8.90106H0.671128V10.8919Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67882 11.5555V10.8919H10.6697V8.90106H11.3333V11.5555H8.67882Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6697 0.893293H8.67882V0.229672H11.3333V2.88416H10.6697V0.893293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.671128 2.88416H0.00750732V0.229672H2.66199V0.893293H0.671128V2.88416Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35687 10.2283V6.91017H4.67498V8.90103H5.3386V9.56465H4.67498V10.2283H1.35687ZM4.01136 7.57379H2.02049V9.56465H4.01136V7.57379Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98394 1.60116V4.91926H8.6567V5.58289H7.99308V4.91926H6.00221V4.25564H6.66583V3.59202H6.00221V2.9284H6.66583V1.60116H9.98394ZM7.32945 4.25564H9.32032V2.26478H7.32945V4.25564Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34774 5.58296H4.67498V6.24658H1.35687V5.58296H2.68411V4.91934H2.02049V4.25572H2.68411V2.92848H2.02049V2.26486H2.68411V1.60124H6.00222V2.26486H5.3386V2.92848H4.67498V2.26486H3.34774V2.92848H4.01136V3.5921H3.34774V5.58296Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68411 8.901H3.34773V8.23738H2.68411V8.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99307 8.901H8.65669V8.23738H7.99307V8.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6567 6.91017H9.98394V10.2283H6.66583V6.91017H7.99307V6.24655H8.6567V6.91017ZM7.32945 7.57379V9.56465H9.32032V7.57379H7.32945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98393 5.58296V6.24658C9.82339 6.24658 8.81836 6.24658 8.65669 6.24658V5.58296H9.98393Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99307 3.59204H8.65669V2.92842H7.99307V3.59204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33859 4.25574H6.00221V3.59212H5.33859V4.25574Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01135 3.59207H4.67497C4.67497 3.75262 4.67497 4.75764 4.67497 4.91931H4.01135V3.59207Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67497 5.58289H5.33859V4.91926H4.67497V5.58289Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02049 4.25574H1.35687V2.9285H2.02049C2.02049 3.08904 2.02049 4.09407 2.02049 4.25574Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35687 2.26489H2.02049V1.60127H1.35687V2.26489Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33859 10.2283H6.00221V9.56465H5.33859V10.2283Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33859 7.57376H6.00221C6.00221 7.73431 6.00221 8.73933 6.00221 8.901H5.33859V7.57376Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00221 6.24654V6.91016H5.33859V5.58291H7.99308V6.24654H6.00221Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.81ac5d5ac43efc0363d0d9e384da8a3f.svg";
export { ForwardRef as ReactComponent };